import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ticketSelection", "customAmount", "amountField", "ticketRefundAmount", "feeRefundAmount",
    "totalRefundAmount", 'purchasedTicket', 'firstForm', 'confirmationSection', 'refundType', 'displayRefundReason',
    'confirmTotalAmount', 'refundReason', 'selectedOption']

  static values = {
    orderRefundableAmount: Number,
    alertMessages: Object,
  }

  connect() {
    // Monitor value changes every 100ms when field is focused
    this.valueMonitor = null
    this.lastKnownValue = null

    if (this.hasAmountFieldTarget) {
      this.amountFieldTarget.addEventListener('focus', () => {
        this.startValueMonitoring()
      })

      this.amountFieldTarget.addEventListener('blur', () => {
        this.stopValueMonitoring()
      })
    }

    // Set initial refund type display text
    this.selectedOptionTargets.forEach(option => {
      if (option.checked) this.refundTypeTarget.innerText = option.dataset.displayValue
    })

    this.updateSummary()
  }

  startValueMonitoring() {
    this.lastKnownValue = this.amountFieldTarget.value
    this.valueMonitor = setInterval(() => {
      const currentValue = this.amountFieldTarget.value
      if (currentValue !== this.lastKnownValue) {
        this.lastKnownValue = currentValue
        this.calculateCustomAmount()
      }
    }, 50) // Check every 50ms
  }

  stopValueMonitoring() {
    if (this.valueMonitor) {
      clearInterval(this.valueMonitor)
      this.valueMonitor = null
    }
  }

  disconnect() {
    this.stopValueMonitoring()
  }

  updateSummary() {
    const refundType = this.element.querySelector('input[name="refund_type"]:checked')?.value

    switch (refundType) {
      case 'complete':
        // Only refund ticket prices (no fees)
        this.updateSummaryAmounts(this.orderRefundableAmountValue, 0)
        break
      case 'partial':
        this.calculatePartialAmount()
        break
      case 'custom':
        this.calculateCustomAmount()
        break
      default:
        this.updateSummaryAmounts(0, 0)
    }
  }

  updateSummaryAmounts(ticketAmount, transactionAndStubFee = 0) {
    this.ticketRefundAmountTarget.textContent = this.formatCurrency(ticketAmount)
    this.feeRefundAmountTarget.textContent = this.formatCurrency(transactionAndStubFee)
    this.totalRefundAmountTarget.textContent = this.formatCurrency(ticketAmount + transactionAndStubFee)
  }

  handleRefundTypeChange(event) {
    const refundType = event.target.value

    if (this.hasTicketSelectionTarget) this.ticketSelectionTarget.classList.add('d-none')
    if (this.hasCustomAmountTarget) this.customAmountTarget.classList.add('d-none')

    this.refundTypeTarget.innerText = event.target.dataset.displayValue

    switch (refundType) {
      case 'partial':
        this.ticketSelectionTarget.classList.remove('d-none')
        break
      case 'custom':
        this.customAmountTarget.classList.remove('d-none')
        break
    }

    this.updateSummary()
  }

  calculatePartialAmount() {
    let totalAmount = 0

    const checkedBoxes = this.element.querySelectorAll('input[name="selected_tickets[]"]:checked')

    checkedBoxes.forEach(checkbox => {
      let ticketPrice = parseFloat(checkbox.dataset.price)
      totalAmount += ticketPrice
    })

    // Only refund ticket prices, no fees
    this.updateSummaryAmounts(totalAmount, 0)
  }

  calculateCustomAmount() {
    const refundAmount = parseFloat(this.amountFieldTarget.value || 0)
    this.updateSummaryAmounts(refundAmount, 0)
  }

  formatCurrency(amount) {
    return parseFloat(amount).toFixed(2);
  }

  showConfirmationSection() {
    if (this.refundReasonTarget.value == '') {
      displayFlashMessage('error', this.alertMessagesValue['select_refund_reason'])
      this.refundReasonTarget.focus()
    } else {
      this.confirmTotalAmountTarget.textContent = this.totalRefundAmountTarget.innerText
      const selectedOption = this.refundReasonTarget.options[this.refundReasonTarget.selectedIndex]
      this.displayRefundReasonTarget.textContent = selectedOption.text
      this.firstFormTarget.classList.add('d-none')
      this.confirmationSectionTarget.classList.remove('d-none')
    }
  }

  hideConfirmationSection() {
    this.confirmationSectionTarget.classList.add('d-none')
    this.firstFormTarget.classList.remove('d-none')
  }
} 